import { useAuthStore } from 'cloak-auth/src/Client/stores';
import Pbf from 'pbf';

import { decode } from './decode';

export async function GeobufFetcher(route: string): Promise<GeoJSON.GeoJSON> {
    const cloak = useAuthStore.getState().keyCloak;
    if (!cloak) {
        throw new Error('Unauthorized');
    }
    await cloak.updateToken(5);
    const res = await fetch(`${process.env.EXPO_PUBLIC_ADDRESS_HOST || ''}/api/${route}`, {
        headers: new Headers({
            Authorization: `Bearer ${cloak.token!}`,
        }),
    });
    if (!res.ok) {
        throw new Error('Failed to fetch locations');
    }

    const buf = await res.arrayBuffer();
    return decode(new Pbf(buf));
}
